import React from 'react';

import { Radio, RadioGroupProps } from 'antd';

const RadioGroupSelect = (props: RadioGroupProps) => {
  return <Radio.Group className="flex" optionType="button" buttonStyle="solid" {...props} />;
};

export default RadioGroupSelect;
